import { useFormStore } from '@/stores/form'
import apiHelperService from '@/services'
import router from '@/router'

const fetchInfo = async () => {
  return await apiHelperService.get(`/api/individual/info`)
}
const getWifePersonalInfo = async (personUN) => {
  return await apiHelperService.get(
    `/api/individual/wifeInfoByIdentityNumberOrUnifiedNumber/${personUN}/null`
  )
}

const initInfo = async () => {
  const formStore = useFormStore()
  const res = await fetchInfo()
  const {
    identityNumber,
    unifiedNumber,
    arabicFullName,
    englishFullName,
    arabicFatherName,
    englishFatherName,
    arabicGrandName,
    englishGrandName,
    arabicFourthName,
    englishFourthName,
    nationalityId,
    passportNumber,
    familySequence,
    familyBookCityCode
  } = res

  formStore.draft.request = {
    ...formStore.draft.request,
    ...{
      applicantIdentityNumber: identityNumber,
      applicantUnUumber: unifiedNumber,
      applicantArbFullName: arabicFullName,
      applicantEngFullName: englishFullName,
      applicantArbFirstName: arabicFatherName,
      applicantEngFatherName: englishFatherName,
      applicantArbThirdName: arabicGrandName,
      applicantEngThirdName: englishGrandName,
      applicantArbFourthName: arabicFourthName,
      applicantEngFourthName: englishFourthName,
      applicantCurNationalityId: nationalityId,
      personUnifiedNumber: unifiedNumber,
      localPassportNumber: passportNumber,
      familyBooKFamilySequence: familySequence,
      FamilyBookCityCode: familyBookCityCode,
      identityNumber
    }
  }
}

export default async function () {
  const formStore = useFormStore()
  const personUN = router.currentRoute.value.query.personUN

  try {
    formStore.extraMap = {}
    await initInfo()
    const response = await getWifePersonalInfo(personUN)
    const {
      unifiedNumber,
      professionId,
      educationLevelId,
      lookupEmirateId,
      englishFirstName,
      arabicFirstName,
      englishFatherName,
      arabicFatherName,
      englishGrandName,
      arabicGrandName,
      englishFourthName,
      arabicFourthName
    } = response

    formStore.draft.request = {
      ...formStore.draft.request,
      ...{
        lookupEmirateId: lookupEmirateId,
        familyMemEngFirstName: englishFirstName,
        familyMemArbFirstName: arabicFirstName,
        familyMemEngFatherName: englishFatherName,
        familyMemArbFatherName: arabicFatherName,
        familyMemEngThirdName: englishGrandName,
        familyMemArbThirdName: arabicGrandName,
        familyMemEngForthName: englishFourthName,
        familyMemArbForthName: arabicFourthName,
        educationLevelId: educationLevelId,
        professionId: professionId,
        familyMemUnNumber: unifiedNumber
      }
    }
  } catch (error) {
    console.error('use766Preload', error)
  }
}
